"use strict";
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-inferrable-types */
Object.defineProperty(exports, "__esModule", { value: true });
var Constants_1 = require("./Constants");
var HttpHeaders_1 = require("../http/HttpHeaders");
var Utilities_1 = require("../common/Utilities");
var ServiceEndpointHelper = /** @class */ (function () {
    function ServiceEndpointHelper() {
    }
    ServiceEndpointHelper.getV2EndpointUrl = function (epid, regionGtms) {
        return regionGtms.chatService + "/v2/users/ME/endpoints/" + epid;
    };
    ServiceEndpointHelper.getThreadUrl = function (threadId, regionGtms) {
        return regionGtms.chatService + "/v1/threads/" + threadId + "?view=msnp24Equivalent";
    };
    ServiceEndpointHelper.getMessagesUrl = function (threadId, regionGtms) {
        return regionGtms.chatService + "/v1/users/ME/conversations/" + threadId + "/messages";
    };
    ServiceEndpointHelper.getBotMessagesUrl = function (botId, regionGtms) {
        return regionGtms.chatService + "/v1/agents/" + botId + "/invoke";
    };
    ServiceEndpointHelper.getAmsObjectsUrl = function (regionGtms) {
        return Utilities_1.default.sanitizeUrlWithBackSlash(regionGtms.ams) + "v1/objects";
    };
    ServiceEndpointHelper.getAmsObjectContentUrl = function (id, regionGtms, isImageFile) {
        if (isImageFile === void 0) { isImageFile = false; }
        var cloudDataContent = isImageFile
            ? Constants_1.default.ImageContent
            : Constants_1.default.FileContent;
        return Utilities_1.default.sanitizeUrlWithBackSlash(regionGtms.ams) + "v1/objects/" + id + "/content/" + cloudDataContent;
    };
    ServiceEndpointHelper.getAmsObjectViewUrl = function (id, regionGtms, isImageFile) {
        if (isImageFile === void 0) { isImageFile = false; }
        var fileView = isImageFile
            ? Constants_1.default.ImageView
            : Constants_1.default.FileView;
        return Utilities_1.default.sanitizeUrlWithBackSlash(regionGtms.ams) + "v1/objects/" + id + "/views/" + fileView;
    };
    ServiceEndpointHelper.getAmsStatusUrl = function (id, regionGtms, isImageFile) {
        if (isImageFile === void 0) { isImageFile = false; }
        var fileView = isImageFile
            ? Constants_1.default.ImageView
            : Constants_1.default.FileView;
        var url = Utilities_1.default.sanitizeUrlWithBackSlash(regionGtms.ams) + "v1/objects/" + id + "/views/" + fileView + "/status";
        return url;
    };
    ServiceEndpointHelper.getV1EndpointUrl = function (regionGtms) {
        return regionGtms.chatService + "/v1/users/ME/endpoints";
    };
    ServiceEndpointHelper.getV1DeleteEndpointUrl = function (regionGtms, epid) {
        return regionGtms.chatService + "/v1/users/ME/endpoints/" + epid;
    };
    ServiceEndpointHelper.getV1SubscriptionUrl = function (regionGtms) {
        return regionGtms.chatService + "/v1/users/ME/endpoints/SELF/subscriptions";
    };
    ServiceEndpointHelper.getV1PollUrl = function (regionGtms, sid) {
        return regionGtms.chatService + "/v1/users/ME/endpoints/SELF/subscriptions/" + sid + "/poll";
    };
    ServiceEndpointHelper.getV1SetPropertiesUrl = function (regionGtms) {
        return regionGtms.chatService + "/v1/users/ME/endpoints/SELF/properties?name=" + HttpHeaders_1.default.SetEndpointProperty;
    };
    return ServiceEndpointHelper;
}());
exports.default = ServiceEndpointHelper;
//# sourceMappingURL=ServiceEndpointHelper.js.map